import { render, staticRenderFns } from "./featuresPopulation.vue?vue&type=template&id=2850bf16&scoped=true&"
import script from "./featuresPopulation.vue?vue&type=script&lang=js&"
export * from "./featuresPopulation.vue?vue&type=script&lang=js&"
import style0 from "./featuresPopulation.vue?vue&type=style&index=0&id=2850bf16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850bf16",
  null
  
)

export default component.exports